export default __webpack_public_path__ + "static/media/select.f58f1d6d.svg";